import { faList, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { useState } from 'react'
import { Loader } from '~/components/Global/Elements/Loader/Loader'
import { Button } from '~/components/Global/Interactions/Button'
import { ButtonVariation } from '~/components/Global/Interactions/Button/ButtonVariation'
import { useDashboardContext } from '~/domains/dashboard/context/DashboardContext'
import { CreateOrderModal } from '~/domains/orders/components/CreateOrderModal'
import { OrdersList } from '~/domains/orders/components/OrdersList'
import type { DashboardBlockLayoutProps } from '../../../types'
import { DashboardBlockLayout } from '../../DashboardBlock/DashboardBlockLayout'

export const LastOpenOrdersBlock = (
  props: DashboardBlockLayoutProps
): ReactElement => {
  const { userIds, isUserIdsLoading } = useDashboardContext()
  const [newOrderModalOpen, setNewOrderModalOpen] = useState(false)
  const navigate = useNavigate()
  if (userIds.length === 0) {
    return <Loader />
  }

  const filters: { [key: string]: string | string[] } = {
    status: '1', // Only open orders
    sort: 'created',
    sortDirection: 'desc' as const
  }

  filters.user = userIds.map(String)

  return (
    <DashboardBlockLayout
      {...props}
      actions={
        <>
          <Button
            variation={ButtonVariation.Neutral}
            buttonSize="extraSmall"
            onClick={() => {
              navigate({ to: '/orders' })
            }}
          >
            <FontAwesomeIcon icon={faList} />
            Voir toutes les commandes
          </Button>
          <Button
            buttonSize="extraSmall"
            variation={ButtonVariation.Neutral}
            onClick={() => setNewOrderModalOpen(true)}
            narrow
          >
            <FontAwesomeIcon icon={faPlus} />
          </Button>
          {newOrderModalOpen && (
            <CreateOrderModal
              open={true}
              onClose={() => setNewOrderModalOpen(false)}
            />
          )}
        </>
      }
    >
      <OrdersList
        filters={filters}
        embedded
        filtersLoading={isUserIdsLoading}
      />
    </DashboardBlockLayout>
  )
}
